import { EditMappingFormValues, EditMappingPayload, EditMode } from "../types/mappingVersion.types";
import { normalizeVersionName } from "../utils/versionName.utils";

interface BuildEditMappingPayloadArgs {
  drawingToolId: string;
  ownerId: string;
  sourceId: string;
  mappingType: number;
  values: EditMappingFormValues;
}

export const buildEditMappingPayload = ({
  drawingToolId,
  ownerId,
  sourceId,
  mappingType,
  values
}: BuildEditMappingPayloadArgs): EditMappingPayload => ({
  drawingToolId,
  ownerId,
  sourceId,
  mappingType,
  reason: values.reason.trim(),
  mode: values.mode,
  versionName: values.mode === EditMode.NewVersion ? normalizeVersionName(values.versionName) : undefined
});

const DUPLICATE_VERSION_NAME_STATUS = 409;

/**
 * Returns a field-level message when the failure is the AC6 duplicate-name conflict,
 * so the caller can attach it to the versionName field instead of only showing a toast.
 * `error` is the raw axios error rejected by the interceptor in api/apiService.ts.
 */
export const resolveDuplicateVersionNameError = (error: any): string | null => {
  const status = error?.response?.status;
  if (status !== DUPLICATE_VERSION_NAME_STATUS) {
    return null;
  }
  return (
    error?.response?.data?.message ||
    "A version with this name already exists for this mapping. Please choose a different name."
  );
};
